import styled from 'styled-components';
import { CaptionBoldLUppercase } from '../../../../styles/globals';
import { IThemeProvider, ITheme } from '../../../../styles/theme';

export const AccordionTableHeaderCont = styled.div`
  display: flex;
  height: 48px;
  align-items: center;
  justify-content: space-between;

  ${({ theme }: IThemeProvider) => `
    padding: 0 30px 0 96px;
    color: ${theme.colors.neutral.primary[80]};
  `};
`;

export const AccHeaderTopic = styled(CaptionBoldLUppercase)`
  display: inline-block;
  flex: 1;
`;

interface IArrowScoreCont {
  asc?: boolean;
  theme: ITheme;
}

export const AccHeaderScoreCont = styled.div<IArrowScoreCont>`
  position: relative;
  flex: 2.35;
  cursor: pointer;

  svg {
    position: relative;
    margin: 0 0 0 7px;
    top: -2px;
    ${({ asc }) => `
    ${
  asc
    ? `
    transform: rotate(180deg);
    top: -2px;
    `
    : ''
}
  `};
  }
`;

export const TileAccHeaderSide = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
`;

interface IAccArrowCont {
  active?: boolean;
  inActive?: boolean;
  theme: ITheme;
}

export const AccArrowCont = styled.div<IAccArrowCont>`
  svg {
    width: 10px;
    height: 5px;
    position: relative;
    top: -2px;

    ${({ active, theme, inActive }) => `
      ${inActive ? 'opacity: 0.4;' : ''}
      ${
  active
    ? `
      transform: rotate(180deg);
      top: -2px;
      `
    : ''
}
      path {
        fill: ${theme.colors.secondary[100]};
      }
  `};
  }
`;
